import { createDirectMessagesReadOutbound, createRequestDirectMessagesLogOutbound } from '../../api/outbound/directMessagesOutbounds';
import { getDirectMessageToastKey } from '../../types/toastTypes';
import { thunkSetActivePanel } from './panelsActions';
import { addToast, thunkCloseToast } from './toastsActions';
export const CLEAR_DIRECT_MESSAGES_STATE = 'CLEAR_DIRECT_MESSAGES_STATE';
export const SET_ACTIVE_DIRECT_MESSAGES_USER = 'SET_ACTIVE_DIRECT_MESSAGES_USER';
export const ADD_DIRECT_MESSAGE = 'ADD_DIRECT_MESSAGE';
export const HANDLE_DIRECT_MESSAGE_BLANK_FROM_INBOUND = 'HANDLE_DIRECT_MESSAGE_BLANK_FROM_INBOUND';
export const SET_DIRECT_MESSAGE_LOG_FROM_INBOUND = 'SET_DIRECT_MESSAGE_LOG_FROM_INBOUND';
export const SET_LAST_READ_DIRECT_MESSAGE = 'SET_LAST_READ_DIRECT_MESSAGE';
export const SET_RECENT_CONVERSATIONS_FROM_INBOUND = 'SET_RECENT_CONVERSATIONS_FROM_INBOUND';
export const RESET_ACTIVE_CONVERSATION = 'RESET_ACTIVE_CONVERSATION';
export function clearDirectMessagesState() {
    return {
        type: CLEAR_DIRECT_MESSAGES_STATE
    };
}
function setActiveDirectMessagesUser(playerIdName) {
    return {
        type: SET_ACTIVE_DIRECT_MESSAGES_USER,
        payload: playerIdName
    };
}
export function thunkOpenDirectMessagesToPlayer(playerIdName, socketSend) {
    return function (dispatch, getState) {
        dispatch(thunkCloseToast(getDirectMessageToastKey(playerIdName.id)));
        dispatch(setActiveDirectMessagesUser(playerIdName));
        dispatch(thunkSetActivePanel('directMessages', socketSend));
        const existingConversation = getState().directMessages.conversations.find((conversation) => conversation.playerIdName.id === playerIdName.id);
        if (existingConversation?.lastReadMessageId !== undefined) {
            // Opening a conversation that has already been fetched at some point. We can mark it as read now, if unread messages exist.
            dispatch(thunkMarkDirectMessagesAsRead(existingConversation, socketSend));
        }
        else {
            // No existing or up-to-date conversation state for this player,
            // probably haven't fetched any messages from this player yet so request player log now.
            socketSend(createRequestDirectMessagesLogOutbound(playerIdName.id));
        }
    };
}
function addDirectMessage(conversationPlayer, fromPlayer, messageId, messageHtml) {
    return {
        type: ADD_DIRECT_MESSAGE,
        payload: { conversationPlayer, fromPlayer, messageId, messageHtml }
    };
}
function maybeDispatchDirectMessageToast(dispatch, getState, conversationPlayer) {
    // show toast notification if not already looking at this conversation:
    const state = getState();
    if (state.directMessages.activeConversationPlayerId === undefined ||
        state.directMessages.activeConversationPlayerId !== conversationPlayer.id ||
        state.panels.activePanelType !== 'directMessages') {
        dispatch(addToast({
            type: 'direct-message',
            key: getDirectMessageToastKey(conversationPlayer.id),
            message: `Message from ${conversationPlayer.name}`,
            action: {
                type: 'open-direct-messages',
                playerIdName: conversationPlayer
            }
        }));
    }
}
export function thunkAddDirectMessageFromInbound(inbound, socketSend) {
    return function (dispatch, getState) {
        const { conversationPlayer, fromPlayer, messageId, messageHtml } = inbound;
        const hadExistingConversation = !!getState().directMessages.conversations.find((currentConversation) => currentConversation.playerIdName.id === conversationPlayer.id);
        dispatch(addDirectMessage(conversationPlayer, fromPlayer, messageId, messageHtml));
        if (!hadExistingConversation) {
            socketSend(createRequestDirectMessagesLogOutbound(conversationPlayer.id));
        }
        maybeDispatchDirectMessageToast(dispatch, getState, conversationPlayer);
    };
}
export const thunkHandleDirectMessageBlankFromInbound = (inbound) => {
    return function (dispatch, getState) {
        maybeDispatchDirectMessageToast(dispatch, getState, { id: inbound.playerId, name: inbound.username });
    };
};
function setDirectMessageLogFromInbound(inbound) {
    return {
        type: SET_DIRECT_MESSAGE_LOG_FROM_INBOUND,
        payload: inbound
    };
}
/**
 * Loading a direct message log for a given conversation is only done while showing that conversation, so we can
 * assume the conversation can be marked as read at this time.
 */
export const thunkSetDirectMessageLogFromInbound = (inbound, socketSend) => {
    return function (dispatch) {
        dispatch(setDirectMessageLogFromInbound(inbound));
        const { lastUnreadMessageId, conversationPlayer } = inbound;
        if (lastUnreadMessageId !== -1) {
            socketSend(createDirectMessagesReadOutbound(conversationPlayer.id, lastUnreadMessageId));
        }
    };
};
function setLastReadDirectMessage(playerId, lastUnreadMessageId) {
    return {
        type: SET_LAST_READ_DIRECT_MESSAGE,
        payload: { playerId, lastUnreadMessageId }
    };
}
export function setRecentConversationsFromInbound(inbound) {
    return {
        type: SET_RECENT_CONVERSATIONS_FROM_INBOUND,
        payload: inbound
    };
}
export const thunkMarkDirectMessagesAsRead = (conversation, socketSend) => {
    return function (dispatch) {
        const { messages, lastReadMessageId, playerIdName } = conversation;
        const lastMessageId = messages.length ? messages[messages.length - 1].id : undefined;
        if (lastMessageId === undefined) {
            // some messages must exist to be marked as read
            return;
        }
        if (lastReadMessageId === undefined || lastReadMessageId < lastMessageId) {
            dispatch(setLastReadDirectMessage(playerIdName.id, lastMessageId));
            socketSend(createDirectMessagesReadOutbound(playerIdName.id, lastMessageId));
        }
    };
};
export function resetActiveConversation() {
    return {
        type: RESET_ACTIVE_CONVERSATION
    };
}
